module.exports = {"create_invoice_simulation":"Crear simulación de factura","date_range":"Rango de fechas","username":"Nombre usuario","device_model":"Modelo dispositivo","select_model":"Elige Modelo","device":"Dispositivo","select_device":"Elige Dispositivo","create":"Crear","invoice simulation":"Simulaciones de factura"}


//////////////////
// WEBPACK FOOTER
// ./src/translates/es/InvoiceSimulation.json
// module id = 604
// module chunks = 1